import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Tabs, Tab } from "react-bootstrap";
import Sidebar from "../../components/Sidebar";
import Breadcrumbs from "../Users/Breadcrumbs";
import { useLocation, useParams } from "react-router-dom";
import { BettingHistoryTab } from "./BettingHistoryTab";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import moment from "moment";

const BattingHistory = () => {
  const params = useParams();
  const location = useLocation();
  let { user,setAccountError } = useContext(AuthContext);
  const [key, setKey] = useState("Exchange");
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [filter, setFilter] = useState({
    toPeriod: currentDate,
    fromPeriod: previousDate,
    filterByDay: "",
    userType: params.type,
    id: params.id,
    page: 1,
    limit: 100,
    // status: "completed",
  });
  const [data, setData] = useState([]);
  const getData = async (type = "search") => {
    // if (filter.filterByDay != "") {
    //   if (filter.filterByDay == "today") {
    //     filter.fromPeriod = currentDate;
    //     filter.toPeriod = currentDate;
    //   }
    //   if (filter.filterByDay == "yesterday") {
    //     filter.fromPeriod = previousDate;
    //     filter.toPeriod = currentDate;
    //   }
    // }
    let path = apiPath.betHistory;

    let obj;
    if (type !== "reset") {
      obj = {
        ...filter,
        betType:
          key == "Exchange"
            ? "betfair"
            : key == "FancyBet"
            ? "fancy"
            : key == "Sportsbook"
            ? "sportBook"
            : key == "BookMaker"
            ? "bookmaker"
            : key == "Tie"
            ? "tie"
            : key == "Toss"
            ? "toss"
            : key == "parlay"
            ? "parlay"
            : "casino",
      };
    } else {
      obj = {
        status: "completed",
        toPeriod: "",
        fromPeriod: "",
        filterByDay: "",
        betType:
          key == "Exchange"
            ? "betfair"
            : key == "FancyBet"
            ? "fancy"
            : key == "Sportsbook"
            ? "sportBook"
            : key == "BookMaker"
            ? "bookmaker"
            : key == "Tie"
            ? "tie"
            : key == "Toss"
            ? "toss"
            : key == "parlay"
            ? "parlay"
            : "casino",
      };
    }

    const { status, data: response_users } = await apiGet(path, obj);
    if (status === 200) {
      if (response_users.success) {
        setData(response_users.results);
        if (response_users.results.data?.length == 0) {
          setAccountError(true);
        } else {
          setAccountError(false);
        }
      }
    }
  };
  useEffect(() => {
    if (filter.filterByDay != "") {
      getData();
    }
  }, [filter.filterByDay]);
  useEffect(() => {
    setFilter({
      toPeriod: currentDate,
      fromPeriod: previousDate,
      filterByDay: "",
      userType: params.type,
      id: params.id,
      page: 1,
      limit: 100,
      // status: "completed",
    });
    setKey("Exchange");
  }, [location, currentDate, previousDate]);

  const handlePageClick = (event) => {
    setFilter((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
    setViewPage(event.selected);
  };
  useEffect(() => {
    setPageCount(data?.totalPages || []);
  }, [data]);
  useEffect(() => {
    // getData();
    setViewPage(filter.page ? filter.page - 1 : 0);
  }, [filter]);

  const redirectCasino = async (userId, platform, platformTxId, type) => {
    const { status, data: response_users } = await apiGet(
      apiPath.casinoWalletHistory +
        "?userId=" +
        userId +
        "&platform=" +
        platform +
        "&platformTxId=" +
        platformTxId
    );
    //console.log(response_users, status);
    if (status === 200) {
      if (response_users.status) {
        if (response_users.data?.status === "0000") {
          if (type === 1) {
            javascript: window.open(
              response_users.data?.txnUrl,
              "_blank",
              "height=900,width=1200"
            );
          } else {
            javascript: window.open(
              response_users.data?.url,
              "_blank",
              "height=900,width=1200"
            );
          }
        } else {
          toast.error(response_users.data.desc);
        }
      } else {
        toast.error(response_users.data.desc);
      }
    } else {
      toast.error(response_users.data.desc);
    }
  };
  return (
    <div className="top-header-inner">
      <section className="py-4 main-inner-outer">
        <Container fluid>
          <Breadcrumbs user_id={params?.id} />
          <div className="accout_cols_outer">
            <div className="left_side">
              <Sidebar />
            </div>
            <div className="right_side">
              <div className="inner-wrapper">
                <h2 className="common-heading">
                  {location.pathname.split("/")[1] == "betting-history"
                    ? "Betting History"
                    : "Betting Profit Loss"}
                </h2>
                <div className="common-tab">
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => {
                      setKey(k);
                      setFilter({
                        page: 1,
                        limit: 100,
                        toPeriod: currentDate,
                        fromPeriod: previousDate,
                        filterByDay: "",
                        userType: params.type,
                        id: params.id,
                      });
                    }}
                  >
                    <Tab eventKey="Exchange" title="Exchange">
                      {key === "Exchange" && (
                        <BettingHistoryTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"betfair"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="FancyBet" title="FancyBet">
                      {key === "FancyBet" && (
                        <BettingHistoryTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"fancy"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="Sportsbook" title="Sportsbook">
                      {key === "Sportsbook" && (
                        <BettingHistoryTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"sportBook"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="BookMaker" title="BookMaker">
                      {key === "BookMaker" && (
                        <BettingHistoryTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"bookmaker"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                        />
                      )}
                    </Tab>
                    {/* <Tab eventKey="casino" title="Casino">
                      {key === "casino" && (
                        <BettingHistoryTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"casino"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          redirectCasino={redirectCasino}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="Toss" title="Toss">
                      {key === "Toss" && (
                        <BettingHistoryTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"toss"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          redirectCasino={redirectCasino}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="Tie" title="Tie">
                      {key === "Tie" && (
                        <BettingHistoryTab
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"tie"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          redirectCasino={redirectCasino}
                        />
                      )}
                    </Tab> */}
                    {/* <Tab eventKey="parlay" title="Parlay">
                      {key === "parlay" && (
                        <BettingHistoryTab
                          title={key}
                          filter={filter}
                          setFilter={setFilter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          
                        />
                      )}
                    </Tab> */}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default BattingHistory;
